import { Typography } from "antd";
import { t } from "i18next";
import React, { useState } from "react";
/** 
* ExpandedComponent เป็นคอมโพเนนต์ที่ใช้สำหรับแสดงข้อความที่สามารถขยายหรือย่อได้ โดยมีการจัดการสถานะการขยายผ่าน props ที่ส่งเข้ามา
* คอมโพเนนต์นี้ใช้ Typography.Paragraph จาก Ant Design เพื่อแสดงข้อความ โดยมีการจัดการการขยายและย่อของข้อความผ่าน ellipsis
 * @param {number|any} row - จำนวนแถวที่จะแสดงก่อนที่จะมีการขยาย
 * @param {string | number} key - คีย์ที่ใช้ในการระบุว่าข้อความนั้นถูกขยายหรือไม่
 * @param {boolean} expanded - สถานะการขยายของข้อความ
 * @param {string | JSX.Element} text - ข้อความที่จะแสดงในคอมโพเนนต์
 * @param {boolean | undefined} copyable - ระบุว่าข้อความสามารถถูกคัดลอกได้หรือไม่
 * @param {string | null} copyTxt - ข้อความที่จะแสดงเมื่อมีการคัดลอกข้อความ
 * @returns {JSX.Element} - คอมโพเนนต์ที่แสดงข้อความที่สามารถขยายหรือย่อได้
*/

export const ExpandedComponent = ({ row, key, expanded, text, copyable, copyTxt }) => {
    const [expand, setExpanded] = useState(expanded);

    const handleExpanded = (key) => {
        if (expand === key) {
            setExpanded(false);
        } else {
            setExpanded(key);
        }
    };
    return (
        <Typography.Paragraph key={99}
            style={{ marginBottom: 0, }}
            className="fs-sm-10 fs-12 text-secondary inline-flex"
            copyable={copyable ? { text: copyTxt, tooltips: false } : false}
            ellipsis={{
                rows: row || 1,
                expandable: 'collapsible',
                expanded: expand === key,
                symbol: expand === key ? null : t("more"),
                onExpand: () => handleExpanded(key),

            }}
        >
            {text}
        </Typography.Paragraph>
    );
}